import React from 'react'
import { Route, Switch } from 'react-router-dom'
import { connectedRouterRedirect } from 'redux-auth-wrapper/history4/redirect'

import Callback from './callback'
import ForgotPassword from './forgot-password'
import NotFound from './not-found'
import Dashboard from './dashboard'
import Login from './login'
import Participant from './participant'
import Password from './password'
import Profile from './profile'

const isAuthenticated = (state) => {
    const accessToken = state.users.userTokens.accessToken
    if (!accessToken) {
        return false
    }
    return !!accessToken.token
}

const isNotAuthenticated = (state) => {
    return !isAuthenticated(state)
}

const auth = connectedRouterRedirect({
    redirectPath: '/',
    authenticatedSelector: isAuthenticated,
    wrapperDisplayName: 'AuthenticatedRoute',
    allowRedirectBack: false
})

const noAuth = connectedRouterRedirect({
    redirectPath: '/dashboard',
    authenticatedSelector: isNotAuthenticated,
    wrapperDisplayName: 'NonAuthenticatedRoute',
    allowRedirectBack: false
})

const Routes = () => {
    return (
        <Switch>
            <Route exact path='/' component={noAuth(Login)}/>
            <Route exact path='/callback' component={noAuth(Callback)}/>
            <Route exact path='/dashboard' component={auth(Dashboard)}/>
            <Route exact path='/forgot-password' component={noAuth(ForgotPassword)}/>
            <Route exact path='/password' component={auth(Password)}/>
            <Route exact path='/profile' component={auth(Profile)}/>
            <Route path='/participants/:id' component={auth(Participant)}/>
            <Route component={noAuth(NotFound)}/>
        </Switch>
    )
}

export default Routes



// WEBPACK FOOTER //
// ./src/components/routes.js